import { useDispatch } from "react-redux";
import { Input } from "../../../components/ui";
import { getCategory } from "../../../helpers/getText";
import useAddParameter from "../add-parameter/useAddParameter";
import RulesSection from "./add-rule";
import { useEffect } from "react";
import { resetAddesRules } from "../../../reducers/riskEngineSlice";

const AddRuleParams = () => {
  const {
    addParameterRuleData,
    handleRuleChange,
    handleAddRule,
    handleDeleteRule,
    addRuleForSelectedParam,
  } = useAddParameter();

  return (
    <div
      className="overflow-y-auto"
      style={{ height: "calc(100vh - 12rem)" }}
      id="scroll_style"
    >
      <Input
        label="Parameter Name"
        required={true}
        disabled={true}
        value={addRuleForSelectedParam?.param_name}
      />

      <div className="flex gap-4 mt-3">
        <Input
          label="Weight"
          required={true}
          disabled={true}
          value={addRuleForSelectedParam?.weight}
          className="flex-1"
        />

        <Input
          label="Category"
          required={true}
          disabled={true}
          value={getCategory(addRuleForSelectedParam?.type)}
          className="flex-1"
        />
      </div>

      <div className="mt-3">
        <Input
          label="Description"
          disabled={true}
          value={addRuleForSelectedParam?.desc}
          className="flex-1"
        />
      </div>

      <div className="mt-4">
        <RulesSection
          rules={addParameterRuleData.rules}
          handleRuleChange={handleRuleChange}
          handleAddRule={handleAddRule}
          handleDeleteRule={handleDeleteRule}
        />
      </div>
    </div>
  );
};
export default AddRuleParams;
